import { LandingPage } from "../../contracts/LandingPage";
import { Promobanner } from "../../contracts/Promobanner";
import { DataMapper } from "..";
import { flattenRichText } from "../api-mappers";

function mapPromoBanner(chunk: any): Promobanner | null {
  if (!chunk) return null;
  const find = (id: string) =>
    chunk.find?.((c: any) => c.id === id) ?? null;
  const fromDate =
    find("fromdate")?.content?.datetime ??
    find("from-date")?.content?.datetime ??
    "";
  const toDate =
    find("todate")?.content?.datetime ??
    find("to-date")?.content?.datetime ??
    "";
  const themeSelection = find("theme")?.content;
  const theme =
    themeSelection?.selectedOptions?.[0]?.key ??
    themeSelection?.selectedItem?.id ??
    themeSelection?.options?.[0]?.key;

  return {
    id: find("id")?.content?.text ?? "",
    fromDate,
    toDate,
    message: flattenRichText(find("message")?.content),
    theme,
    show: find("show")?.content?.value ?? false,
  };
}

export default (data: any): LandingPage => {
  const mapper = DataMapper();
  const firstSeoChunk = data?.meta?.content?.chunks?.[0];
  const firstPromoBannerChunk = data?.promoBanner?.content?.chunks?.[0];
  return {
    name: data.name,
    path: data.path,
    seo: mapper.API.Object.APIMetaSEOComponentToSEO(firstSeoChunk),
    grids: data.grids?.content?.grids
      ? data.grids.content.grids.map((grid: any) => ({
          id: grid.id,
          rows: grid.rows,
        }))
      : [],
    ticker: flattenRichText(data.ticker?.content),
    promoBanner: mapPromoBanner(firstPromoBannerChunk),
    logo: mapper.API.Object.APIImageToImage(data.logo?.content?.images),
  };
};
